import { useEffect } from 'react'
import { Canvas, Text } from 'fabric'
import { getTextObjects } from '../../utils/text/textObject'
import { removeTextObject } from '../utils/textObjectUtils'

/**
 * Параметры для хука очистки текстовых объектов
 */
export interface UseTextObjectCleanupParams {
    fabricCanvasRef: React.MutableRefObject<Canvas | null>
    textObjectRef: React.MutableRefObject<Text | null>
    canvasReadyTrigger?: number
    isUpdatingRef: React.MutableRefObject<boolean>
}

/**
 * Хук для очистки текстовых объектов при изменении canvasReadyTrigger
 * Удаляет все текстовые объекты с canvas при повторном открытии редактора
 */
export function useTextObjectCleanup(params: UseTextObjectCleanupParams): void {
    const {
        fabricCanvasRef,
        textObjectRef,
        canvasReadyTrigger,
        isUpdatingRef,
    } = params

    useEffect(() => {
        if (!fabricCanvasRef.current) {
            return
        }

        const fabricCanvas = fabricCanvasRef.current

        // Удаляем все текстовые объекты при изменении canvasReadyTrigger
        // Это гарантирует чистый canvas при повторном открытии редактора
        const textObjects = getTextObjects(fabricCanvas)

        textObjects.forEach((textObj) => {
            removeTextObject(fabricCanvas, textObj)
        })

        // Очищаем ref
        textObjectRef.current = null
        // Сбрасываем флаг обновления при очистке
        isUpdatingRef.current = false
    }, [canvasReadyTrigger, fabricCanvasRef, textObjectRef, isUpdatingRef])
}
